// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__19v0B","inputWrap":"CustomTip_inputWrap__uOmaF"};